import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL || '';

export interface SessionJoinArgs {
  eventId: string | number;
  email: string;
  userId?: string;
  displayName?: string;
}

export interface SessionLeaveArgs {
  eventId: string | number;
  email: string;
  source?: 'sdk_leave_button' | 'browser_unload';
}

export const postSessionJoin = async (args: SessionJoinArgs): Promise<void> => {
  try {
    await axios.post(
      `${HOSTAPI}/events/${args.eventId}/attendee/session/join`,
      {
        email: args.email,
        userId: args.userId,
        displayName: args.displayName,
      },
      { headers: { 'Content-Type': 'application/json' } },
    );
  } catch (err) {
    console.warn('[session-join] failed', err);
  }
};

export const postSessionLeave = async (args: SessionLeaveArgs): Promise<void> => {
  try {
    await axios.post(
      `${HOSTAPI}/events/${args.eventId}/attendee/session/leave`,
      { email: args.email, source: args.source ?? 'sdk_leave_button' },
      { headers: { 'Content-Type': 'application/json' } },
    );
  } catch (err) {
    console.warn('[session-leave] failed', err);
  }
};

export const sendSessionLeaveBeacon = (args: SessionLeaveArgs): void => {
  const url = `${HOSTAPI}/events/${args.eventId}/attendee/session/leave`;
  const payload = JSON.stringify({
    email: args.email,
    source: args.source ?? 'browser_unload',
  });
  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
  } catch {
    /* fall through */
  }
  try {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* swallow */
  }
};
